export default "__VITE_ASSET__zEN4jkNF__"